<div class="pdf-contents">
  <div class="outline">
    <div>
      <img src="./assets/images/STP_Logo_xsm.png" />
    </div>
    <template #pdfOutlineContainer></template>
  </div>
  <div class="detail">
    @if (pdfOnDisplay == 'unavailable') {
      <div>
        <h3>Sorry, this protocol is not available currently.</h3>
      </div>
    } @else {
      <iframe
        [src]="pdfOnDisplay | safe : 'resourceUrl'"
        class="displayPdf"
        type="application/pdf"
      ></iframe>
    }
  </div>
</div>
